import React from 'react';
import withRequireLogin from '../auth/withRequireLogin';
import { IRoute, IRouterProps } from './types';

interface IRouteProps extends IRouterProps {
  route: IRoute;
}

function Route(props: IRouteProps) {
  const { route, default: defaultRoute, path, ...params } = props;

  const RouteComponent = route.requireLogin
    ? withRequireLogin(route.component)
    : route.component;

  return <RouteComponent {...params} />;
}

export default Route;
